/** Refund history + stats. */
import { endpoints } from '@/config/env';
import type { RefundSummaryResponse } from '@/types';
import { request } from './client';

export function fetchRefunds(
  page = 0,
  size = 20,
  range: { from?: string; to?: string } = {},
  signal?: AbortSignal,
): Promise<RefundSummaryResponse | null> {
  return request<RefundSummaryResponse | null>(endpoints.refunds(page, size, range), { signal });
}
